import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu'
import Logo from '@/components/shared/Logo'
import PreservedLink from '@/components/shared/PreservedLink'

import CTAButton from '@/components/shared/CTAButton'
import { lendersData, vehicleMakesData } from '@/shared/navigationData'

const DesktopHeader = () => {
  return (
    <div className="container mx-auto hidden max-w-[90%] items-center justify-between py-1.5 lg:flex lg:max-w-[85%] xl:max-w-[80%]">
      <div className="flex flex-shrink-0 items-center">
        <Logo />
      </div>
      <div className="flex flex-1 justify-center px-4 md:px-6 lg:px-8">
        <NavigationMenu>
          <NavigationMenuList className="gap-1 md:gap-2 lg:gap-4 xl:gap-6">
            <NavigationMenuItem>
              <NavigationMenuTrigger className="text-base font-semibold">
                Lenders
              </NavigationMenuTrigger>
              <NavigationMenuContent>
                <div className="w-[1000px] p-8">
                  <h3 className="mb-6 text-sm font-bold tracking-wider text-gray-800 uppercase">
                    Popular Lenders:
                  </h3>
                  <ul className="grid grid-cols-5 gap-x-16 gap-y-4">
                    {lendersData.map(lender => (
                      <li key={lender.href} className="min-w-0">
                        <NavigationMenuLink asChild>
                          <PreservedLink
                            to={lender.href}
                            className="inline-block rounded-md px-2 py-1.5 text-sm font-medium whitespace-nowrap text-gray-700 transition-colors hover:bg-gray-100 hover:text-[oklch(0.6942_0.1185_194.77)] focus:outline-none"
                          >
                            {lender.title}
                          </PreservedLink>
                        </NavigationMenuLink>
                      </li>
                    ))}
                  </ul>
                </div>
              </NavigationMenuContent>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuTrigger className="text-base font-semibold">
                Vehicles
              </NavigationMenuTrigger>
              <NavigationMenuContent>
                <div className="w-[1000px] p-8">
                  <h3 className="mb-6 text-sm font-bold tracking-wider text-gray-800 uppercase">
                    Popular Vehicles:
                  </h3>
                  <ul className="grid grid-cols-5 gap-x-16 gap-y-4">
                    {vehicleMakesData.map(vehicle => (
                      <li key={vehicle.href} className="min-w-0">
                        <NavigationMenuLink asChild>
                          <PreservedLink
                            to={vehicle.href}
                            className="inline-block rounded-md px-2 py-1.5 text-sm font-medium whitespace-nowrap text-gray-700 transition-colors hover:bg-gray-100 hover:text-[oklch(0.6942_0.1185_194.77)] focus:outline-none"
                          >
                            {vehicle.title}
                          </PreservedLink>
                        </NavigationMenuLink>
                      </li>
                    ))}
                  </ul>
                </div>
              </NavigationMenuContent>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuLink asChild>
                <PreservedLink
                  to="/about-us"
                  className="bg-background inline-flex h-9 w-max items-center justify-center rounded-md px-4 py-2 text-base font-semibold transition-colors hover:bg-gray-100 hover:text-[oklch(0.6942_0.1185_194.77)] focus:outline-none"
                >
                  About Us
                </PreservedLink>
              </NavigationMenuLink>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <NavigationMenuLink asChild>
                <PreservedLink
                  to="/contact"
                  className="bg-background inline-flex h-9 w-max items-center justify-center rounded-md px-4 py-2 text-base font-semibold transition-colors hover:bg-gray-100 hover:text-[oklch(0.6942_0.1185_194.77)] focus:outline-none"
                >
                  Contact Us
                </PreservedLink>
              </NavigationMenuLink>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>
      </div>
      <div className="flex flex-shrink-0 items-center">
        <CTAButton text="START YOUR CLAIM NOW" className="h-10 px-5 text-sm" />
      </div>
    </div>
  )
}

export default DesktopHeader
